export default __webpack_public_path__ + "static/media/banner-image.992ac5be.jpg";